// eslint-disable-next-line import/no-cycle
import {
  CHANGE_MODE,
  CHANGE_CHART
} from '../actions';

export const changeMode = (data) => ({
  type: CHANGE_MODE,
  payload: data,
});

export const changeChart = (data) => ({
  type: CHANGE_CHART,
  payload: data,
});
